// @view/authentication/PasswordResetLogo.view.tsx

import React from "react";
import * as styles from "@styles/PasswordReset.css";
import type { PasswordResetCompleteViewProps } from "@ps-bridge/contracts/passwordResetComplete";

type PasswordResetLogoViewProps = Pick<PasswordResetCompleteViewProps, "logoUri">;

const PasswordResetLogoView: React.FC<PasswordResetLogoViewProps> = ({ logoUri }) => {
  return <img className={styles.logo} src={logoUri} alt="Ouroboros Logo" />;
};

export default PasswordResetLogoView;
